import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "svg-icon svg-icon-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  fill: "none",
  viewBox: "0 0 24 24",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    xmlns: "http://www.w3.org/2000/svg",
    opacity: "0.5",
    x: "11.364",
    y: "20.364",
    width: "16",
    height: "2",
    rx: "1",
    transform: "rotate(-90 11.364 20.364)",
    fill: "black"
  }),
  /*#__PURE__*/_createElementVNode("rect", {
    xmlns: "http://www.w3.org/2000/svg",
    x: "4.36396",
    y: "11.364",
    width: "16",
    height: "2",
    rx: "1",
    fill: "black"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, _hoisted_3))
}